import React, { useMemo } from 'react';

import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import { EMediaWidth } from '@r1-frontend/ui-react/tokens/mediaWidth';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import {
    getArrTemplateForCountCards,
    getEndCarouselRowPos,
    getStartCarouselRowPos,
    sortFunctionBySort,
} from '~/src/features/yandex-landing/utils';
import type { IProps } from '~/src/features/yandex-landing/YandexCatalog/types';
import YandexStationCards from '~/src/features/yandex-landing/YandexStationCards';

import * as ST from './styled';

const YandexCatalog: React.FC<IProps> = ({ yandexStationData }) => {
    const isSDesktopMin = useMatchMedia(EMediaWidth.sDesktopMin);

    const yandexStationDataSorted = useMemo((): IEquipment[] => (
        [...yandexStationData].sort(sortFunctionBySort)
    ), [yandexStationData]);

    if (!yandexStationDataSorted.length) {
        return null;
    }

    return (
            <ST.ContainerCatalog>
                <ST.CatalogWrapper>
                    <ST.TextCatalogWrapper>
                        <ST.TitleCatalog>
                            {'Яндекс.Станций \nмного не бывает'}
                        </ST.TitleCatalog>
                            <ST.SubtextCatalog>
                                Выберите свою
                            </ST.SubtextCatalog>
                    </ST.TextCatalogWrapper>
                    {isSDesktopMin
                        ? <ST.CardsWrapper count={yandexStationDataSorted.length}>
                                <YandexStationCards yandexStationDataSorted={yandexStationDataSorted}/>
                            </ST.CardsWrapper>
                        : <>
                            {[...getArrTemplateForCountCards(yandexStationDataSorted).keys()].map((key) => (
                                <YandexStationCards
                                    data-id={key}
                                    key={yandexStationDataSorted[key].id}
                                    yandexStationDataSorted={yandexStationDataSorted}
                                    startLine={getStartCarouselRowPos(yandexStationDataSorted.length)[key]}
                                    endLine={getEndCarouselRowPos(yandexStationDataSorted.length)[key]}
                                    isCarousel={true}
                                />
                            ))}
                        </>
                    }
                </ST.CatalogWrapper>
            </ST.ContainerCatalog>
        );
};

export default YandexCatalog;
